/**
 * Tenant List column sort contract — VISTOERA_TENANT_LIST_COLUMN_SEMANTIC_
 * DEFAULT_SORT_DIRECTION_NULL_ORDERING_AND_SORT_STATE_CONTRACT_P0_V1.
 *
 * Mirrors ``backend/app/saas/services/tenant_list_sort_contract.py``.
 * AntD Table first-click direction is controlled per-column via
 * ``sortDirections`` derived from ``defaultDirection`` here — never
 * scattered `if` blocks inside individual column renderers.
 */
import type { TenantListSortField } from '../types'

export type TenantListSortDir = 'asc' | 'desc'

export interface TenantListColumnSortDefinition {
  key: TenantListSortField
  defaultDirection: TenantListSortDir
  semantic: string
}

export const TENANT_LIST_SORT_DEFINITIONS: Record<TenantListSortField, TenantListColumnSortDefinition> = {
  name: { key: 'name', defaultDirection: 'asc', semantic: 'DISPLAY_NAME' },
  status: { key: 'status', defaultDirection: 'desc', semantic: 'STATUS_PRIORITY' },
  plan_key: { key: 'plan_key', defaultDirection: 'desc', semantic: 'PLAN_CATALOG_ORDER' },
  expires_at: { key: 'expires_at', defaultDirection: 'asc', semantic: 'EXPIRATION_DATE' },
  credit_balance: { key: 'credit_balance', defaultDirection: 'asc', semantic: 'LEDGER_BALANCE' },
  credit_usage_1d: { key: 'credit_usage_1d', defaultDirection: 'desc', semantic: 'USAGE_WINDOW_1D' },
  credit_usage_7d: { key: 'credit_usage_7d', defaultDirection: 'desc', semantic: 'USAGE_WINDOW_7D' },
  credit_usage_30d: { key: 'credit_usage_30d', defaultDirection: 'desc', semantic: 'USAGE_WINDOW_30D' },
  storage_used_bytes: { key: 'storage_used_bytes', defaultDirection: 'desc', semantic: 'USED_BYTES' },
  scale: { key: 'scale', defaultDirection: 'desc', semantic: 'SITE_MEMBER_TUPLE' },
  member_count: { key: 'member_count', defaultDirection: 'desc', semantic: 'ACTIVE_MEMBER_COUNT' },
  recent_activity_at: { key: 'recent_activity_at', defaultDirection: 'desc', semantic: 'LAST_ACTIVITY' },
  created_at: { key: 'created_at', defaultDirection: 'desc', semantic: 'CREATED_AT' },
}

/** AntD two-state cycle: first click = semantic default, second = reverse. */
export const TENANT_LIST_SORT_CYCLE = 'TWO_STATE_DEFAULT_THEN_REVERSE' as const

export function sortDirectionsFor(
  field: TenantListSortField,
): ['ascend', 'descend'] | ['descend', 'ascend'] {
  const def = TENANT_LIST_SORT_DEFINITIONS[field]
  return def.defaultDirection === 'desc' ? ['descend', 'ascend'] : ['ascend', 'descend']
}
